export default "__VITE_ASSET__BoMLUYKD__"